module.exports = __webpack_public_path__ + "images/goal-oriented-177f47e1289aae61105a57ac52528444.png";